import { render } from "./Portfolio.vue?vue&type=template&id=45079cee"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"
script.render = render

export default script